import React from 'react';
import { Link } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Alert, Card } from 'react-bootstrap';
import '../routes/AuthPage.css'; // For specific card styles, titles, links, etc.

const AuthFormLayout = ({
    pageTitle,
    children,
    errorMsg,
    setErrorMsg,
    submitStatus,
    setSubmitStatus,
    onGoogleSuccess,
    onGoogleError,
    toggleLinkPath,
    toggleLinkText,
    toggleQuestionText,
    brandName = "MyFit Menu AI",
    footerText = "Smart nutrition, intelligently simple."
}) => {
    return (
        <Card className="p-3 p-sm-4 p-md-5 shadow-lg rounded-4 auth-card w-100" style={{ maxWidth: '500px' }}> {/* rounded-4 for 1rem */}
            <Card.Body className="d-flex flex-column">
                <div className="mb-3">
                    <Link to="/" className="auth-back-button d-inline-flex align-items-center text-decoration-none">
                        <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                        Back to Home
                    </Link>
                </div>

                <div className="text-center mb-4">
                    <Link to="/" className="text-decoration-none">
                        <h2 className="mt-1 auth-brand-title">{brandName}</h2>
                    </Link>
                </div>
                <h3 className="mb-4 text-center auth-form-title">{pageTitle}</h3>

                {errorMsg && <Alert variant="danger" onClose={() => setErrorMsg('')} dismissible className="mb-3">{errorMsg}</Alert>}
                {submitStatus && submitStatus.message && (
                    <Alert variant={submitStatus.type} onClose={() => setSubmitStatus({ type: '', message: '' })} dismissible className="mb-3">
                        {submitStatus.message}
                    </Alert>
                )}

                <div className="flex-grow-1 mb-3"> {/* Added mb-3 for spacing before OR divider */}
                    {children}
                </div>

                <div className="text-center my-3 or-divider"><span>OR</span></div>
                <div className="d-flex justify-content-center google-login-button-container mb-3">
                    <GoogleLogin
                        onSuccess={onGoogleSuccess}
                        onError={onGoogleError}
                        useOneTap
                        shape="pill"
                        type="standard"
                        logo_alignment="left"
                    />
                </div>
                <div className="text-center mt-auto toggle-form-text"> {/* mt-auto to push following to bottom */}
                    <p className="mb-0">{toggleQuestionText} <Link to={toggleLinkPath} className="fw-medium">{toggleLinkText}</Link></p> {/* Bootstrap fw-medium */}
                </div>
                <footer className="pt-4 text-center text-muted small auth-footer"> {/* Removed mt-auto, relies on toggle-form-text */}
                    {footerText}
                </footer>
            </Card.Body>
        </Card>
    );
};

export default AuthFormLayout;